var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-price.j2"] = require( "macros/product-price.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/cart-confirm-meta.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-price.j2", false, "core/templates/header/cart-confirm-meta.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("price", t_1);
output += "<h2 class=\"c-cart-confirm__h2\" data-qa-confirm-title>\n    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"displayName"), env.opts.autoescape);
output += "\n</h2>\n\n<h2 class=\"c-cart-confirm__price\" data-qa-confirm-price>\n    ";
output += runtime.suppressValue((lineno = 8, colno = 28, runtime.callWrap(runtime.memberLookup((t_1),"displayPriceValue"), "price[\"displayPriceValue\"]", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"price"),runtime.contextOrFrameLookup(context, frame, "core")])), env.opts.autoescape);
output += "\n</h2>\n\n";
if(runtime.contextOrFrameLookup(context, frame, "mto")) {
output += "\n    <div class=\"c-mto-cart-confirm__swatches\">\n        ";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"swatches");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("swatch", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n            <div class=\"c-mto-cart-confirm__swatch\">\n                <img class=\"c-mto-cart-confirm__swatch-img\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"swatchUrl"), env.opts.autoescape);
output += "\" data-qa-confirm-swatch/>\n            </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n";
;
}
else {
output += "\n    <p class=\"c-cart-confirm__p\">\n\n        <span class=\"c-cart-confirm__color-title\">\n            ";
output += runtime.suppressValue((lineno = 23, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["core_header-cart-confirm-label-transform",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"primaryLabel")]})])), env.opts.autoescape);
output += "\n        </span>\n\n        <span class=\"c-cart-confirm__color\" data-qa-confirm-color>\n\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"colorName"), env.opts.autoescape);
output += "\n\n        </span>\n\n    </p>\n\n    <p class=\"c-cart-confirm__p\">\n\n        <span class=\"c-cart-confirm__size-title\" data-qa-confirm-size-title>\n            ";
output += runtime.suppressValue((lineno = 37, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["core_header-cart-confirm-label-transform",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"secondaryLabel")]})])), env.opts.autoescape);
output += "\n        </span>\n\n        <span class=\"c-cart-confirm__size\" data-qa-confirm-size>\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"size"), env.opts.autoescape);
output += "\n        </span>\n\n    </p>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/cart-confirm-meta.j2"] , dependencies)